var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./VueExcelXlsx.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler?id=data-v-47f99f0c!../vue-loader/lib/selector?type=template&index=0!./VueExcelXlsx.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-excel-xlsx/VueExcelXlsx.vue
// module id = 877
// module chunks = 1